/// 拉承一体 状态
export const TraffichavenStatus = {
  DEFAULT: 1, /// 默认
  LOADING: 2, /// 加载中
  FINISH: 3, /// 完成
};

// 内部的 变了
let gTraffichavenStatus = TraffichavenStatus.FINISH;

// 外部或者状态
export function getTraffichavenStatus() {
  return gTraffichavenStatus;
}

// 外部设置状态
export function setupTraffichavenStatus(tatus) {
  gTraffichavenStatus = tatus;
}
